// import { useDraggable } from '@dnd-kit/core';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import React, { CSSProperties, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { ProIconButton } from '../../../../../atoms/Button/ProIconButton';
import { ProIcon } from '../../../../../atoms/Icons/Icon';
import { ProIconData, ProIconDataButtons } from '../../../../../atoms/Icons/IconData';
import { ProIntent, ProSize } from '../../../../../utils/enums';
import { Components } from '../../../../../utils/types';

export const StroryDraggable = ({
    children,
    id,
    req,
    selectElement,
}: PropsWithChildren<{ id: string; req: Components.Schemas.RequirementDTO; selectElement: (id?: string) => void }>) => {
    const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
        id: id,
    });
    const style: CSSProperties = {
        position: isDragging ? 'absolute' : 'relative',
        transform: CSS.Translate.toString(transform),
    };

    const { t } = useTranslation();

    return (
        <button ref={setNodeRef} style={style} className="Daily__story-row_dragButton">
            <li>
                {children}
                <span {...listeners} {...attributes}>
                    <ProIcon
                        icon={ProIconData.drag_handle}
                        size={ProSize.Small}
                        intent={ProIntent.PrimaryLight}
                        customHeight="23px"
                        customWidth="15px"
                    />
                </span>
                <span
                    onClick={(e) => {
                        selectElement(req.id);
                        e?.stopPropagation();
                    }}
                    className="Daily__story-row_dragButton_nameRow"
                >
                    <ProIcon icon={ProIconData.scope_fill} size={ProSize.Small} />
                    <span>{req.name}</span>
                </span>

                <div className="Daily__story-row_actionCell">
                    <ProIconButton
                        icon={ProIconDataButtons.arrow_right_xs}
                        tooltip={t('buttons.open')}
                        mainIntent={ProIntent.Transparent}
                        hoverIntent={ProIntent.Secondary}
                        size={ProSize.XSmall}
                        lineIntent={ProIntent.Secondary}
                        placement="bottom"
                        small
                        onClick={(e) => {
                            selectElement(req.id);
                            e?.stopPropagation();
                        }}
                    />
                </div>
            </li>
        </button>
    );
};
